<template>
  <v-container fluid>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2 v-if="!isJwMode && (mode === 'transport' || mode === 'transport_disposal')">
          <v-icon class="mr-2">
            mdi-format-list-text
          </v-icon>
          受注（回収・持込・積替・搬入）
        </h2>
        <h2 v-if="isJwMode || mode === 'disposal'">
          <v-icon class="mr-2">
            mdi-format-list-text
          </v-icon>
          受注
        </h2>
      </v-col>
    </v-row>
    <!-- /ヘッダー -->

    <!-- ステータスボタン１段目 -->
    <v-row>
      <v-col>
        <v-item-group v-model="selectedButton">
          <v-row>
            <!-- 未受付 -->
            <v-col>
              <v-item v-slot="{ active, toggle }" value="requested">
                <v-card
                  :color="active ? 'primary-gradients' : ''"
                  class="rounded-card"
                  @click="toggle"
                >
                  <v-card-text>
                    <v-row class="status-card">
                      <v-col
                        v-if="$vuetify.breakpoint.mdAndUp"
                        cols="12"
                        md="7"
                        class="image-col"
                      >
                        <v-layout :justify-center="true">
                          <v-img
                            max-height="90"
                            aspect-ratio="1"
                            contain
                            :src="
                              require(`@/assets/images/order/accept_statuses/request.png`)
                            "
                          />
                        </v-layout>
                      </v-col>
                      <v-col cols="12" md="5" class="status-col">
                        <div
                          class="fill-width"
                          :class="active ? 'white--text' : ''"
                        >
                          <div
                            class="text-center font-weight-bold"
                            :class="
                              $vuetify.breakpoint.xlOnly ? '' : 'to-small-font'
                            "
                          >
                            <span :style="`line-height: ${$vuetify.breakpoint.smAndUp ? 3 : 4}`">未受付</span>
                          </div>
                          <div class="text-center">
                            <span class="text-h5 font-weight-bold">
                              {{ summaries.requested_count }}
                            </span>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
            <!-- /未受付 -->

            <!-- 受注 -->
            <v-col>
              <v-item v-slot="{ active, toggle }" value="ordered">
                <v-card
                  :color="active ? 'primary-gradients' : ''"
                  class="rounded-card"
                  @click="toggle"
                >
                  <v-card-text>
                    <v-row class="status-card">
                      <v-col
                        v-if="$vuetify.breakpoint.mdAndUp"
                        cols="12"
                        md="7"
                        class="image-col"
                      >
                        <v-layout :justify-center="true">
                          <v-img
                            max-height="90"
                            aspect-ratio="1"
                            contain
                            :src="
                              require(`@/assets/images/order/accept_statuses/accepting_order.png`)
                            "
                          />
                        </v-layout>
                      </v-col>
                      <v-col cols="12" md="5" class="status-col">
                        <div
                          class="fill-width"
                          :class="active ? 'white--text' : ''"
                        >
                          <div
                            class="text-center font-weight-bold"
                            :class="
                              $vuetify.breakpoint.xlOnly ? '' : 'to-small-font'
                            "
                          >
                            <span :style="`line-height: ${$vuetify.breakpoint.smAndUp ? 3 : 4}`">受注</span>

                          </div>
                          <div class="text-center">
                            <span class="text-h5 font-weight-bold">
                              {{ summaries.ordered_count }}
                            </span>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
            <!-- /受注 -->

            <!-- 予約済 -->
            <v-col v-if="!isAllocate">
              <v-item v-slot="{ active, toggle }" value="reserved">
                <v-card
                  :color="active ? 'primary-gradients' : ''"
                  class="rounded-card"
                  @click="toggle"
                >
                  <v-card-text>
                    <v-row class="status-card">
                      <v-col
                        v-if="$vuetify.breakpoint.mdAndUp"
                        cols="12"
                        md="7"
                        class="image-col"
                      >
                        <v-layout :justify-center="true">
                          <v-img
                            max-height="90"
                            aspect-ratio="1"
                            contain
                            :src="
                              require(`@/assets/images/order/accept_statuses/transport_completed.png`)
                            "
                          />
                        </v-layout>
                      </v-col>
                      <v-col cols="12" md="5" class="status-col">
                        <div
                          class="fill-width"
                          :class="active ? 'white--text' : ''"
                        >
                          <div
                            class="text-center font-weight-bold"
                            :class="
                              $vuetify.breakpoint.xlOnly ? '' : 'to-small-font'
                            "
                          >
                            <span style="line-height: 3">予約済</span>
                          </div>
                          <div class="text-center">
                            <span class="text-h5 font-weight-bold">
                              {{ summaries.reserved_count }}
                            </span>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
            <!-- /予約済 -->

            <!-- 配車済 -->
            <v-col v-if="isAllocate">
              <v-item v-slot="{ active, toggle }" value="dispatched">
                <v-card
                  :color="active ? 'primary-gradients' : ''"
                  class="rounded-card"
                  @click="toggle"
                >
                  <v-card-text>
                    <v-row class="status-card">
                      <v-col
                        v-if="$vuetify.breakpoint.mdAndUp"
                        cols="12"
                        md="7"
                        class="image-col"
                      >
                        <v-layout :justify-center="true">
                          <v-img
                            max-height="90"
                            aspect-ratio="1"
                            contain
                            :src="
                              require(`@/assets/images/order/accept_statuses/allocation_completed.png`)
                            "
                          />
                        </v-layout>
                      </v-col>
                      <v-col cols="12" md="5" class="status-col">
                        <div
                          class="fill-width"
                          :class="active ? 'white--text' : ''"
                        >
                          <div
                            class="text-center font-weight-bold"
                            :class="
                              $vuetify.breakpoint.xlOnly ? '' : 'to-small-font'
                            "
                          >
                            <div :style="`line-height: ${$vuetify.breakpoint.smAndUp ? 1 : 2}`">配車済</div>
                            <div :style="`line-height: ${$vuetify.breakpoint.mdAndUp ? 2 : 2}`">予約済</div>
                          </div>
                          <div class="text-center">
                            <span class="text-h5 font-weight-bold">
                              {{ summaries.dispatched_count }}
                            </span>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
            <!-- /配車済 -->

            <!-- 回収完了 -->
            <v-col v-if="isAllocate">
              <v-item v-slot="{ active, toggle }" value="collected">
                <v-card
                  :color="active ? 'primary-gradients' : ''"
                  class="rounded-card"
                  @click="toggle"
                >
                  <v-card-text>
                    <v-row class="status-card">
                      <v-col
                        v-if="$vuetify.breakpoint.mdAndUp"
                        cols="12"
                        md="7"
                        class="image-col"
                      >
                        <v-layout :justify-center="true">
                          <v-img
                            max-height="90"
                            aspect-ratio="1"
                            contain
                            :src="
                              require(`@/assets/images/order/accept_statuses/transport_completed.png`)
                            "
                          />
                        </v-layout>
                      </v-col>
                      <v-col cols="12" md="5" class="status-col">
                        <div
                          class="fill-width"
                          :class="active ? 'white--text' : ''"
                        >
                          <div
                            class="text-center font-weight-bold"
                            :class="
                              $vuetify.breakpoint.xlOnly ? '' : 'to-small-font'
                            "
                          >
                            <span :style="`line-height: ${$vuetify.breakpoint.smAndUp ? 3 : 1}`">回収完了</span>

                          </div>
                          <div class="text-center">
                            <span class="text-h5 font-weight-bold">
                              {{ summaries.collected_count }}
                            </span>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
            <!-- /回収完了 -->

            <!-- 登録完了 -->
            <v-col>
              <v-item v-slot="{ active, toggle }" value="completed">
                <v-card
                  :color="active ? 'primary-gradients' : ''"
                  class="rounded-card"
                  @click="toggle"
                >
                  <v-card-text>
                    <v-row class="status-card">
                      <v-col
                        v-if="$vuetify.breakpoint.mdAndUp"
                        cols="12"
                        md="7"
                        class="image-col"
                      >
                        <v-layout :justify-center="true">
                          <v-img
                            max-height="90"
                            aspect-ratio="1"
                            contain
                            :src="
                              require(`@/assets/images/order/accept_statuses/register_completed.png`)
                            "
                          />
                        </v-layout>
                      </v-col>
                      <v-col cols="12" md="5" class="status-col">
                        <div
                          class="fill-width"
                          :class="active ? 'white--text' : ''"
                        >
                          <div
                            class="text-center font-weight-bold"
                            :class="
                              $vuetify.breakpoint.xlOnly ? '' : 'to-small-font'
                            "
                          >
                            <span :style="`line-height: ${$vuetify.breakpoint.smAndUp ? 3 : 1}`">登録完了</span>
                          </div>
                          <div class="text-center">
                            <span class="text-h5 font-weight-bold">
                              {{ summaries.completed_count }}
                            </span>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
            <!-- /登録完了 -->

            <!-- キャンセル -->
            <v-col>
              <v-item v-slot="{ active, toggle }" value="canceled">
                <v-card
                  :color="active ? 'primary-gradients' : ''"
                  class="rounded-card"
                  @click="toggle"
                >
                  <v-card-text>
                    <v-row class="status-card">
                      <v-col
                        v-if="$vuetify.breakpoint.mdAndUp"
                        cols="12"
                        md="7"
                        class="image-col"
                      >
                        <v-layout :justify-center="true">
                          <v-img
                            max-height="90"
                            aspect-ratio="1"
                            contain
                            :src="
                              require(`@/assets/images/order/accept_statuses/cancel.png`)
                            "
                          />
                        </v-layout>
                      </v-col>
                      <v-col cols="12" md="5" class="status-col">
                        <div
                          class="fill-width"
                          :class="active ? 'white--text' : ''"
                        >
                          <div
                            class="text-center font-weight-bold"
                            :class="
                              $vuetify.breakpoint.xlOnly ? '' : 'to-small-font'
                            "
                          >
                            <span :style="`line-height: ${$vuetify.breakpoint.smAndUp ? 3 : 1}`">キャンセル</span>
                          </div>
                          <div class="text-center">
                            <span class="text-h5 font-weight-bold">
                              {{ summaries.canceled_count }}
                            </span>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
            <!-- /キャンセル -->
          </v-row>
        </v-item-group>
      </v-col>
    </v-row>
    <!-- /ステータスボタン１段目 -->

    <!-- 絞り込み条件 -->
    <v-row>
      <v-col>
        <order-accept-search-block
          ref="searchBlock"
          :conditions.sync="conditions"
          :condition-patterns.sync="conditionPatterns"
          :selectable-condition-pattern.sync="selectableConditionPattern"
          :drivers="drivers"
          :vote-staffs="voteStaffs"
          :is-billing="isBilling"
          :stop-search="stopSearch"
          @search="searchCallback"
          @clear="clearCallback"
          @addConditionPattern="addConditionPatternCallback"
          @removeConditionPattern="removeConditionPatternCallback"
          @userTabChange="handleUserTabChange"
          @update:selectableConditionPattern="selectableConditionPatternChangeCallback"
        />
      </v-col>
    </v-row>
    <!-- /絞り込み条件 -->

    <!-- ボタン -->

    <!-- /ボタン -->
    <v-row dense>
      <v-col>
        <div
          class="d-flex pt-4"
          :class="haba"
        >
          <div class="mb-2">
            <div class="d-flex align-center week-selector">
              <!-- 前の週へ移動ボタン -->
              <v-btn
                icon
                @click="moveToPreviousWeek"
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>

              <!-- 1週間分の日付ボタン -->
              <div>
                <v-tooltip
                  v-for="dateInfo in weekDates"
                  :key="dateInfo.date"
                  bottom
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      :class="[
                      'date-button',
                      { 'today-border': dateInfo.isToday },
                      { 'blue--text': dateInfo.isSaturday && conditions.target_date !== dateInfo.date },
                      { 'red--text': dateInfo.isSunday && conditions.target_date !== dateInfo.date },
                      { 'primary white--text': conditions.target_date === dateInfo.date },
                      { 'white': conditions.target_date !== dateInfo.date }
                    ]"
                      @click="dateButtonClick(dateInfo.date)"
                    >
                      <div style="text-align: center; line-height: 1.2;">
                        <div style="font-size: 0.8rem;">{{ dateInfo.dayOfWeek }}</div>
                        <div style="font-size: 0.7rem; font-weight: bold;">{{ dateInfo.displayDate }}</div>
                      </div>
                    </v-btn>
                  </template>
                  <span>回収日: {{ dateInfo.date }}</span>
                </v-tooltip>
              </div>

              <!-- 次の週へ移動ボタン -->
              <v-btn
                icon
                @click="moveToNextWeek"
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </div>
          </div>
          <div class="mb-2">
            <v-btn
              v-if="isEcContractSinglePlan"
              :class="blinkingButton ? 'blinkButton' : ''"
              @click="ecContractSinglePlanButtonClickEvent"
            >
              <v-icon>mdi-download</v-icon>&nbsp;出力履歴
            </v-btn>
            <output-reservation-dialog
              v-else
              section="accept_order"
              button-class="d-inline-block mr-3"
              :enable-blink="blinkingButton"
              @stopBlinkCallback="blinkingButton = false"
            />

            &nbsp;
            <!-- CSV出力 -->
            <v-btn
              v-if="mode === 'disposal'"
              color="info"
              :disabled="isJwMode"
              @click="exportButtonClickEvent('order_plain')"
            >
              <v-icon>mdi-file-download-outline</v-icon>&nbsp;<span v-if="$vuetify.breakpoint.mdAndUp">CSV</span>出力
            </v-btn>
            <v-menu v-else offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="info"
                  :disabled="isJwMode"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-file-download-outline</v-icon>&nbsp;<span v-if="$vuetify.breakpoint.mdAndUp">CSV</span>出力
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="exportButtonClickEvent('order_plain')">
                  <v-list-item-title>産廃回収</v-list-item-title>
                </v-list-item>
                <v-list-item @click="exportButtonClickEvent('order_general')">
                  <v-list-item-title>一廃回収</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <!-- CSV取込 -->
            <v-btn
              v-if="mode === 'disposal'"
              color="info"
              :disabled="isJwMode"
              class="ml-2"
              @click="importButtonClickEvent('order_plain')"
            >
              <v-icon>mdi-file-upload-outline</v-icon>&nbsp;<span v-if="$vuetify.breakpoint.mdAndUp">CSV</span>取込
            </v-btn>
            <v-menu v-else offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="info"
                  :disabled="isJwMode"
                  class="ml-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-file-upload-outline</v-icon>&nbsp;<span v-if="$vuetify.breakpoint.mdAndUp">CSV</span>取込
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="importButtonClickEvent('order_plain')">
                  <v-list-item-title>産廃回収</v-list-item-title>
                </v-list-item>
                <v-list-item @click="importButtonClickEvent('order_general')">
                  <v-list-item-title>一廃回収</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            &nbsp;
            <v-btn
              v-if="isEcContractSinglePlan"
              color="primary"
              class="text-h6"
              x-large
              @click="ecContractSinglePlanButtonClickEvent"
            >
              産廃回収&nbsp;
              <v-icon large> mdi-plus </v-icon>
            </v-btn>

            <template v-if="isJwMode">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    class="text-h6"
                    x-large
                    v-bind="attrs"
                    v-on="on"
                  >
                    産廃回収&nbsp;
                    <v-icon large> mdi-plus </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="addPickupButtonClickEvent(conditions.plan_date)">
                    <v-list-item-title>新規作成（積替）</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="addCarryInButtonClickEvent(conditions.plan_date)">
                    <v-list-item-title>新規作成（搬入）</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="duplicatePickupButtonClickEvent">
                    <v-list-item-title> 複写して作成 </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>

            <template v-if="mode === 'disposal'">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    class="text-h6"
                    x-large
                    v-bind="attrs"
                    v-on="on"
                  >
                    産廃回収&nbsp;
                    <v-icon large> mdi-plus </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="addSelfEmissionButtonClickEvent(conditions.plan_date)">
                    <v-list-item-title>排出持込</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="addProxyRequestButtonClickEvent(conditions.plan_date)">
                    <v-list-item-title>他社運搬</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="addGeneralButtonClickEvent(conditions.plan_date)">
                    <v-list-item-title>一廃回収</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="duplicatePickupButtonClickEvent">
                    <v-list-item-title> 複写して作成 </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>

            <template v-if="!isEcContractSinglePlan && !isJwMode && mode !== 'disposal'">
              <span :class="{ 'breaker': $vuetify.breakpoint.smAndDown }"></span>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                  >
                    その他受注&nbsp;
                    <v-icon> mdi-plus </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="addSelfEmissionButtonClickEvent(conditions.plan_date)">
                    <v-list-item-title>排出持込</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="addProxyRequestButtonClickEvent(conditions.plan_date)">
                    <v-list-item-title>他社運搬</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="addGeneralButtonClickEvent(conditions.plan_date)">
                    <v-list-item-title>一廃回収</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="addPickupButtonClickEvent(conditions.plan_date)">
                    <v-list-item-title>積替運搬</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="addCarryInButtonClickEvent(conditions.plan_date)">
                    <v-list-item-title>搬入予約</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="duplicatePickupButtonClickEvent">
                    <v-list-item-title> 複写して作成 </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              &nbsp;
              <v-btn
                color="primary"
                class="text-h6"
                x-large
                @click="!isJwMode && mode !== 'disposal' ? addCollectionButtonClickEvent(conditions.plan_date) : null"
              >
                産廃回収&nbsp;
                <v-icon large> mdi-plus </v-icon>
              </v-btn>
            </template>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row class="white">
      <v-col
        cols="12"
        md="6"
        style="vertical-align: middle"
      >
        <div>
          <small>排出者承認　<span style="color: #F0C000">▲</span>：未承認　<span style="color: #f57c00">●</span>：承認済（本登録前）　<span style="color: #0074BA">●</span>：承認済（本登録済）　<span style="color: red">×</span>：差戻</small><br>
          <small>回収・積替・搬入日　<span style="color: #3cbf91">●</span>：過去マニフェスト</small>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>

    <!-- 一覧 -->
    <v-row>
      <v-col>
        <v-card flat>
          <v-data-table
            v-model="rowSelected"
            :headers="fixedTableHeader"
            :items="orders"
            :items-per-page="-1"
            hide-default-footer
            disable-sort
            show-select
            @click:row="toggleRowSelection"
          >
            <!-- ステータス -->
            <template v-slot:[`item.status`]="{ item }">
              <v-chip
                x-small
                label
                :color="item.status | status_chip_order_color(item.order_type)"
              >
                {{ item.status | status_to_label_accept(item.order_type, isAllocate) }}
              </v-chip>
              <v-tooltip
                v-if="item.rejection_reason"
                top
                :open-on-hover="false"
              >
                <template #activator="{ on }">
                  <v-btn
                    icon
                    small
                    retain-focus-on-click
                    @click="on.click"
                    @blur="on.blur"
                  >
                    <v-icon small class="error--text">
                      mdi-information-outline
                    </v-icon>
                  </v-btn>
                </template>
                <small>
                  {{ item.rejection_reason }}
                </small>
              </v-tooltip>
              <div class="text-left">
                <v-btn v-if="item.manifest_number && item.order_type !== 'general'"
                  text
                  color="primary"
                  x-small
                  class="pa-0"
                  style="font-size: 0.75rem; min-width: auto;"
                  @click="manifestNumberClickEvent(item)"
                >
                  {{ item.manifest_number }}
                  <small>
                    <span v-if="item.total_manifests_count > 0" >&emsp;全&nbsp;{{ item.total_manifests_count }}件</span>
                  </small>
                </v-btn>
                <v-btn
                  v-else-if="item.manifest_number && item.order_type === 'general'"
                  text
                  x-small
                  class="pa-0"
                  :ripple="false"
                  style="font-size: 0.75rem;"
                >
                  {{ item.manifest_number }}
                  <small>
                    <span v-if="item.total_manifests_count > 0" >&emsp;全&nbsp;{{ item.total_manifests_count }}件</span>
                  </small>
                </v-btn>
              </div>
            </template>
            <!-- ステータス -->

            <!-- オーダー番号/受注日 -->
            <template v-slot:[`item.order_no`]="{ item }">
              <div>{{ item.order_no }}&nbsp;</div>
              <small class="text--disabled">
                {{ item.order_date | date_format }}
              </small>
            </template>
            <!-- /オーダー番号/受注日 -->

            <!-- 依頼番号/依頼日 -->
            <template v-slot:[`item.request_no`]="{ item }">
              <div>{{ item.request_no }}&nbsp;</div>
              <span v-if="item.request_no">
                <small class="text--disabled">
                  {{ item.created_at | unix_date_format }}
                </small>
              </span>
            </template>
            <!-- 依頼番号/依頼日 -->

            <!-- 回収・積替・搬入日 -->
            <template v-slot:[`item.target_date`]="{ item }">
              <span v-if="item.target_urgent && !item.target_date"> 至急 </span>
              <span v-else>
                <span v-if="item.target_date">
                  <span v-if="item.past_manifest" style="color: #3cbf91">
                    ●
                  </span>
                  {{ item.target_date | date_format }}
                </span>
              </span>
              <div>
                <span v-if="item.driver">
                  <small>{{ item.driver.name }}</small>
                </span>
                &nbsp;
              </div>
            </template>
            <!-- /回収・積替・搬入日 -->

            <!-- 承認状況 -->
            <template v-slot:[`item.remand_count`]="{ item }">
              <div v-if="item.status !== 'collection_canceled' && item.active_emission_approval_count > 0 && ['collection', 'self_emission', 'proxy_request'].includes(item.order_type)">
                <span v-if="item.active_remand_manifest" style="color: red">
                  ×
                </span>
                <span v-else-if="item.active_emission_approval_count === item.active_approved_count && item.active_approved_count === item.active_manifest_registered_count" style="color: #0074BA">
                  ●
                </span>
                <span v-else-if="item.active_emission_approval_count === item.active_approved_count && item.active_approved_count !== item.active_manifest_registered_count" style="color: #f57c00">
                  ●
                </span>
                <span v-else-if="item.active_send_target_manifest || item.active_await_approval_manifest" style="color: #F0C000">
                  ▲
                </span>
                <span v-else-if="item.active_before_reserve_manifest">
                  ー
                </span>
              </div>
            </template>
            <!-- /承認状況 -->

            <!-- 取引先 -->
            <template v-slot:[`item.supplier`]="{ item }">
              <div>
                <div class="inline-flex-container">
                  <div
                    :title="item.supplier.name"
                    class="line-clamp one-clamp"
                  >
                    {{ item.supplier.name }}
                  </div>
                  <v-tooltip top :open-on-hover="false">
                    <template #activator="{ on }">
                      <v-btn
                        icon
                        tile
                        small
                        retain-focus-on-click
                        class="map-icon"
                        @click="on.click"
                        @blur="on.blur"
                      >
                        <v-icon small>mdi-map-marker-outline</v-icon>
                      </v-btn>
                    </template>
                    <div>
                      <strong>{{ item.supplier.name }}</strong>
                      <br />
                      <small>{{ item.supplier.address }}</small>
                    </div>
                  </v-tooltip>
                </div>
              </div>
              <div>
                <div class="inline-flex-container">
                  <div
                    :title="item.supplier_location.name"
                    class="line-clamp one-clamp"
                  >
                    {{ item.supplier_location.name }}
                  </div>
                  <v-tooltip top :open-on-hover="false">
                    <template #activator="{ on }">
                      <v-btn
                        v-if="item.supplier_location.name"
                        icon
                        tile
                        small
                        retain-focus-on-click
                        class="map-icon"
                        @click="on.click"
                        @blur="on.blur"
                      >
                        <v-icon small>mdi-map-marker-outline</v-icon>
                      </v-btn>
                    </template>
                    <div>
                      <strong>{{ item.supplier_location.name }}</strong>
                      <br />
                      <small>{{ item.supplier_location.address }}</small>
                    </div>
                  </v-tooltip>
                </div>
              </div>
            </template>
            <!-- /取引先 -->

            <!-- 運搬先事業場/処分事業場 全◯件-->
            <template v-slot:[`item.destination_location`]="{ item }">
              <div
                :title="item.destination_location.name"
                class="line-clamp one-clamp"
              >
                {{ item.destination_location.name }}
              </div>
              <div
                :title="item.disposer_location_name"
                class="line-clamp one-clamp float-left"
                style="max-width: 76%;width: auto;"
              >
                {{ item.disposer_location_name }}
              </div>
              <span v-if="item.total_traders_count > 0">&emsp;全&nbsp;{{ item.total_traders_count }}件</span>
            </template>
            <!-- /運搬先事業場/処分事業場  全◯件-->

            <!-- 品目/荷姿 -->
            <template v-slot:[`item.item`]="{ item }">
              <div v-if="item.item_name">
                <v-chip
                  :title="item.item_name"
                  color="#F0E6D0"
                  label
                  x-small
                >
                  {{ item.item_name }}
                </v-chip>
              </div>
              <small
                >{{ item.packing_name
                }}<span v-if="item.total_items_count > 0"
                  >&emsp;全&nbsp;{{ item.total_items_count }}件</span
                ></small
              >
            </template>
            <!-- /品目/荷姿 -->

            <!-- 取引番号 -->
            <template v-slot:[`item.deal_no`]="{ item }" v-if="isBilling">
              <v-btn
                v-if="item.deal_no && !item.not_recorded_sales"
                text
                color="primary"
                x-small
                class="pa-0"
                style="font-size: 0.75rem; min-width: auto;"
                @click="transactionNoClickEvent(item)"
              >
                {{ item.deal_no }}
              </v-btn>
              <span v-else-if="item.not_recorded_sales">&emsp;</span>
              <v-btn
                v-else
                text
                color="primary"
                x-small
                class="pa-0"
                style="font-size: 0.75rem; min-width: auto;"
                @click="transactionNoClickEvent(item)"
              >
                ー
              </v-btn>
              <div>
                <span v-if="item.total_amount">
                  {{ parseFloat(item.total_amount) | comma_format }}
                </span>
              </div>
            </template>
            <!-- 取引番号 -->

            <!-- 編集 -->
            <template v-slot:[`item.editable`]="{ item }">
              <v-menu bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-horizontal</v-icon>
                  </v-btn>
                </template>
                {{ item.name }}
                <v-list dense>
                  <v-list-item
                    v-if="canTransitionToEdit(item)"
                    link
                    @click="editButtonClickEvent(item)"
                  >
                    <v-list-item-title>
                      {{
                        canEditCollectionAccepted(item)
                          ? "受注編集"
                          : "受注登録"
                      }}
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item v-else link @click="showButtonClickEvent(item)">
                    <v-list-item-title> 詳細を参照 </v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    v-if="isAllocate && item.order_type === 'self_emission' && item.status === 'collection_accepted'"
                    link
                    @click="selfEmissionReservationButtonClickEvent(item)"
                  >
                    <v-list-item-title>予約登録</v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    v-if="item.can_directly_complete"
                    link
                    @click="directlyCompleteButtonClickEvent(item)"
                  >
                    <v-list-item-title> 登録完了にする </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="['collection_reserved'].includes(item.status) ||
                    (item.order_type === 'general' && item.status === 'collection_completed')
                    "
                    link
                    @click="backCollectionAcceptClickEvent(item)"
                  >
                    <v-list-item-title> 受注に戻る </v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    v-if="canDuplicateOrder(item)"
                    link
                    @click="duplicateButtonClickEvent(item)"
                  >
                    <v-list-item-title> 複写 </v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    v-if="
                      [
                        'collection_accepted',
                        'collection_allocated',
                        'collection_transported',
                        'collection_reserved',
                        'pickup_accepted',
                        'pickup_allocated',
                        'pickup_transported',
                        'carry_in_accepted',
                      ].includes(item.status) ||
                      (item.status === 'collection_requested' &&
                        item.request_no == null) || item.can_directly_cancel
                    "
                    link
                    @click="cancelButtonClickEvent(item)"
                  >
                    <v-list-item-title>
                      <strong class="error--text"> キャンセル </strong>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="['collection_canceled', 'pickup_canceled', 'carry_canceled'].includes(item.status)"
                    link
                    @click="deleteButtonClickEvent(item)"
                  >
                    <v-list-item-title>
                      <strong class="error--text"> 削除 </strong>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <!-- 編集 -->

          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <!-- /一覧 -->

    <!-- ページャー -->
    <v-row class="mb-15">
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>

    <v-footer fixed class="mb-13" color="white" width="100%;" style="overflow-x: auto;">
      <v-card flat width="100%">
        <v-card-actions>
          <v-btn
            color="error"
            class="mr-3"
            :disabled="rowSelected.length <= 0"
            @click="cancellationButtonClickEvent"
          >
            {{ selectedButton === 'canceled' ? '削除' : 'キャンセル' }}
          </v-btn>
          <v-spacer />
          <!-- 受渡確認票出力 -->
          <v-btn
            color="info"
            class="mr-3"
            :disabled="rowSelected.length <= 0"
            @click="outputManifestButtonClickEvent"
          >
            受渡確認票出力
          </v-btn>
          <!-- /受渡確認票出力 -->
          <!-- 一覧表出力 -->
          <v-btn
            color="info"
            class="mr-3"
            :disabled="rowSelected.length <= 0"
            @click="outputListButtonClickEvent"
          >
            一覧表出力
          </v-btn>
          <!-- /一覧表出力 -->
          <v-btn
            v-if="!isAllocate"
            color="primary"
            class="mr-3"
            :disabled="rowSelected.length <= 0"
            @click="reservationButtonClickEvent"
          >
            予約登録
          </v-btn>
          <v-menu :disabled="rowSelected.length <= 0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                :disabled="rowSelected.length <= 0"
                class="mr-3"
                color="primary"
              >
                運搬終了報告兼本登録
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item
                link
                @click="completionReportDialogClickEvent"
              >
                <v-list-item-title> 個別登録 </v-list-item-title>
              </v-list-item>
              <v-list-item
                link
                @click="bulkCompletionReportDialogClickEvent"
              >
                <v-list-item-title> 一括登録 </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-card-actions>
      </v-card>
    </v-footer>

    <!-- /ページャー -->
    <confirm ref="confirm" />
    <!-- 運搬終了報告(個別) -->
    <completion-report-dialog
      :enable-dialog="enableCompletionDialog"
      type="Accepts"
      :order-ids="targetOrderIds"
      :manifest-ids="targetManifestIds"
      :sort-type="conditions.sort_type"
      @cancelCallback="dialogCloseCallback"
      @registerEvent="editDialogRegisterCallback"
    />
    <!-- /運搬終了報告(個別) -->
    <!-- 運搬終了報告(一括) -->
    <bulk-completion-dialog
      :enable-dialog="enableBulkCompletionDialog"
      type="Accepts"
      :order-ids="targetOrderIds"
      :manifest-ids="targetManifestIds"
      @cancelCallback="dialogCloseCallback"
      @registerEvent="editDialogRegisterCallback"
    />
    <!-- /運搬終了報告(一括) -->
    <!-- 複写して作成 -->
    <duplicate-order-dialog
      :enable-dialog="enableDuplicateDialog"
      :vote-staffs="voteStaffs"
      @cancelCallback="dialogCloseCallback"
      @registerCallback="duplicateOrderDialogCallback"
    />
    <!-- /複写して作成 -->
    <reject-reason-dialog
      :enable-dialog="enableRejectReasonDialog"
      @closeCallback="dialogCloseCallback"
      @registerCallback="rejectReasonDialogCallback"
    />
    <!-- アップグレード誘導モーダル -->
    <ec-contract-single-plan-guide-dialog
      :enable-dialog="enableEcContractSinglePlanGuideDialog"
      :from-order="true"
      @closeCallback="dialogCloseCallback"
    />
    <!-- /アップグレード誘導モーダル -->
    <v-dialog v-model="enableWarningDialog" persistent width="500">
      <v-card>
        <v-card-title class="text-h5 red darken-2 white--text">
          確認
        </v-card-title>
        <v-divider />
        <v-card-text>
          <h4 class="mt-4">
            {{ warningDialogMessage }}
          </h4>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn @click="enableWarningDialog = false"> 閉じる </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="removeErrorDialog" persistent width="500">
      <v-card>
        <v-card-title class="text-h5 red darken-2 white--text">
          キャンセル
        </v-card-title>
        <v-divider />
        <v-card-text class="mt-5">
          <p>{{ removeErrorMessage }}</p>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="
              removeErrorMessage = null;
              removeErrorDialog = false;
            "
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import BulkCompletionDialog from "../../dialogs/_BulkCompletionReportDialog";
import ChooseSupplierButton from "@/driver/components/ChooseSupplierButton.vue";
import CompletionReportDialog from "../../dialogs/_CompletionReportDialog";
import Confirm from "../../../../components/Confirm";
import DuplicateOrderDialog from "../components/_DuplicateOrderDialog";
import RejectReasonDialog from "../components/_RejectionReasonDialog";
import DownloadMixin from '../../../../mixins/download-mixin'
import CustomPagination from "@/driver/components/_CustomPagination.vue";
import OutputReservationDialog from "@/driver/components/OutputReservationDialog.vue";
import EcContractSinglePlanGuideDialog from '../../dialogs/_EcContractSinglePlanGuideDialog'
import InfiniteTransportRouteAutoComplete from "@/driver/components/InfiniteTransportRouteAutoComplete.vue";
import OrderAcceptSearchBlock from "@/driver/pages/orders/accepts/_SearchBlock.vue";

export default {
  name: "DriverAcceptOrders",
  components: {
    OrderAcceptSearchBlock,
    OutputReservationDialog,
    CustomPagination,
    BulkCompletionDialog,
    CompletionReportDialog,
    Confirm,
    DuplicateOrderDialog,
    RejectReasonDialog,
    EcContractSinglePlanGuideDialog,
  },
  mixins: [
    DownloadMixin,
  ],
  props: {},
  data() {
    return {
      page: 1,
      perPage: 50,
      totalVisible: 7,
      enableDuplicateDialog: false,
      removeErrorDialog: false,
      removeErrorMessage: null,
      selectedButton: null,
      rowSelected: [],
      voteStaffs: [],
      enableRejectReasonDialog: false,
      cancelTargetId: null,
      cancelTargetType: null,
      weekStartDate: null, // 週の開始日
      conditionPatterns: [],
      selectableConditionPattern: 0,
      conditions: {
        /* 取引先（排出）事業者ID */
        supplier_id: null,
        supplier_type: null,
        /* 取引先（排出）事業場ID */
        supplier_location_id: null,
        /* 取引先（排出）事業場コード */
        supplier_location_code: null,
        /* 運搬担当者 */
        report_transport_user_id: null,
        report_transport_user_name: null,
        /* 取引先（収運・処分）業者ID */
        supplier_trader_id: null,
        supplier_trader_type: null,
        /* 取引先（収運・処分）事業場ID */
        supplier_trader_location_id: null,
        /* 取引先（収運・処分）事業場コード */
        supplier_trader_location_code: null,
        /* 受注種別 */
        order_type: null,
        /* 回収日なし */
        collected_date_type: null,
        /* 回収・積替・搬入日(開始日) */
        collected_start_date: null,
        /* 回収・積替・搬入日(終了) */
        collected_end_date: null,

        /* DXE起票担当者 */
        vote_staff: null,
        /* 排出者承認 */
        approval_state: null,
        /* ドライバー */
        driver_id: null,
        driver_name: null,

        /* 受注番号 */
        order_number: null,
        /* 依頼番号有無 */
        request_number_flag: null,
        /* 依頼番号 */
        request_number: null,
        /* 取引番号有無 */
        deal_number_flag: null,
        /* 取引番号 */
        deal_number: null,
        /* 廃棄物の名称 */
        waste_name: null,

        /* マニフェスト区分 */
        manifest_type: null,
        /* 運搬先 */
        keyword: null,
        /* 検索キーワード */
        search_keyword: null,
        /* 表示順 */
        sort_type: "updated_date_desc",

        /* マニフェスト検索キーワード */
        manifest_search_keyword: null,
        /* 排出事業場コード */
        location_code: null,
        /* 排出事業場名 */
        location_name: null,
        /* 運搬ルート */
        transport_route_id: null,

        target_date: null,
        plan_date: null,
      },
      /** ドライバー */
      drivers: [],
      orders: [],
      fixedTableHeader: [],
      summaries: {
        requested_count: 0,
        ordered_count: 0,
        dispatched_count: 0,
        collected_count: 0,
        completed_count: 0,
        canceled_count: 0,
        reserved_count: 0,
        carryin_contact_count: 0,
        carryin_reception_count: 0,
        carryin_canceled: 0,
      },
      enableCompletionDialog: false,
      enableBulkCompletionDialog: false,
      enableEcContractSinglePlanGuideDialog: false,
      locations: [],
      targetOrderIds: [],
      targetManifestIds: [],
      enableWarningDialog: false,
      warningDialogMessage: null,
      blinkingButton: false,
      stopSearch: false,
    };
  },
  computed: {
    ...mapState("DriverOrderAccept", {
      pagination: "pagination",
      searchCondition: "condition",
      selectableTab: "selectableTab"
    }),
    ...mapState("DriverTenantConfiguration", {
      isAllocate: "use_allocate",
      isBilling: "use_billing",
      isJwMode: 'use_jw_mode',
      mode: "mode",
      isEcContractSinglePlan: 'use_ec_contract_single_plan',
      isProxyEntry: 'use_proxy_entry',
    }),
    haba () {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return "justify-lg-space-between justify-md-space-between";
      } else {
        return "flex-column";
      }
    },
    /**
     * 1週間分の日付を生成
     */
    weekDates() {
      const dates = [];
      const startDate = this.weekStartDate ? this.$dayjs(this.weekStartDate) : this.$dayjs().startOf('week');

      for (let i = 0; i < 7; i++) {
        const date = startDate.clone().add(i, 'days');
        const dayOfWeek = date.day(); // 0:日曜, 1:月曜, ..., 6:土曜
        dates.push({
          date: date.format('YYYY-MM-DD'),
          displayDate: date.format('M/D'),
          dayOfWeek: date.format('ddd'),
          dayNumber: dayOfWeek,
          isToday: date.isSame(this.$dayjs(), 'day'),
          isSaturday: dayOfWeek === 6,
          isSunday: dayOfWeek === 0,
        });
      }
      return dates;
    },
  },
  watch: {
    selectedButton() {
      this.searchButtonClickEvent();
    },
    weekStartDate() {
      // 週を移動した際に、選択状態を保持するため、強制的に再設定
      this.$nextTick(() => {
        // searchForms.target_dateは既に保持されているので、何もしない
        // Vue の reactivity により自動的に v-model が再評価される
      });
    },
  },
  created() {
    if (this.$route.params.resetCondition) {
      this.resetState();
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination();
    }
    if (this.$route.query.d !== undefined) {
      this.resetState();
      this.resetPagination();
      this.selectedButton = this.$route.params.status;
      this.conditions.manifest_type = this.$route.params.manifest_type;
      this.conditions.collected_end_date = this.$route.params.collected_end_date;
    } else if (this.$route.params.order_no) {
      this.resetState()
      this.conditions.order_number = this.$route.params.order_no;
    } else {
      this.selectedButton = this.searchCondition.status;
      Object.assign(this.conditions, this.searchCondition);
    }

    this.selectableConditionPattern = this.selectableTab;

    this.$store.watch(
      (state) => state.DriverOrderAccept.selectableTab,
      (newValue) => {
        this.selectableConditionPattern = newValue;
      }
    );

    this.page = this.pagination.current_page;
    this.perPage = this.searchCondition.limit;

    // 週の開始日を初期化（今週の開始日）
    this.weekStartDate = this.$dayjs().startOf('week').format('YYYY-MM-DD');
    this.buildTableHeader();

    this.fetchDrivers().then((content) => { this.drivers = content.drivers; });
    this.fetchVoteStaffs().then((content) => { this.voteStaffs = content.vote_staffs });

    this.loadConditionPatterns()

    this.searchOrders();
  },
  methods: {
    ...mapActions("DriverOrderAcceptCollectionReservation", {
      reservationOrders: "update",
    }),
    ...mapActions("DriverOrderAcceptCollectionCancellation", {
      cancelCollectionOrder: "update",
    }),
    ...mapActions("DriverOrderReportConfirmationVerification", {
      verification: "show",
    }),
    ...mapActions("DriverOrderConfirmationSlipVerification", {
      slipVerification: "show",
    }),
    ...mapActions("DriverOrderConfirmationListVerification", {
      listVerification: "show",
    }),
    ...mapActions("DriverOrderAcceptSummary", {
      fetchSummaries: "index",
    }),
    ...mapActions("DriverOrderAccept", {
      fetchOrders: "index",
      resetState: "resetState",
      resetPagination: "resetPagination",
    }),
    ...mapActions("DriverOrderAcceptCollection", {
      deleteCollection: "delete",
    }),
    ...mapActions("DriverOrderAcceptBackorder", {
      backOrder: "update",
    }),
    ...mapActions("DriverOrderAcceptPickup", {
      deletePickup: "delete",
    }),
    ...mapActions("DriverOrderAcceptDirectlyCancel", {
      cancellationOrder: "delete",
    }),
    ...mapActions("DriverOrderAcceptDirectlyHidden", {
      deleteOrder: "delete",
    }),
    ...mapActions("DriverOrderAcceptDirectlyComplete", {
      directlyComplete: 'update'
    }),
    ...mapActions("DriverOrderAcceptCarryIn", {
      deleteCarryIn: "delete",
    }),
    ...mapActions("DriverMasterSearchDriver", {
      fetchDrivers: "index",
    }),
    ...mapActions("DriverOrderAcceptCollectionRegistrationRejection", {
      rejectCollection: "update",
    }),
    ...mapActions("DriverOrderAcceptPickupRegistrationRejection", {
      rejectionPickup: "update",
    }),
    ...mapActions("DriverOrderAcceptCarryInsRegistrationRejection", {
      rejectionCarryIn: "update",
    }),
    ...mapActions("DriverSalesDeal", {
      fetchDeal: "show",
    }),
    ...mapActions("DriverOrderAcceptOutputReservation", {
      outputReserve: 'create'
    }),
    ...mapActions('DriverMasterSearchVoteStaff', {
      fetchVoteStaffs: 'index',
    }),
    ...mapActions('DriverOrderSelfEmissionDefinitiveRegistration', {
      selfEmissionDefinitiveRegistration: 'update',
    }),
    ...mapActions("DriverMasterConditionPattern", {
      fetchConditionPatterns: "index",
      fetchConditionPattern: "show",
      destroyConditionPattern: "destroy",
    }),
    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent() {
      this.page = 1;
      const $self = this;
      setTimeout($self.searchOrders, 500);
    },
    /**
     * 一覧 行選択イベント
     * @param item
     */
    toggleRowSelection(item) {
      console.log('toggleRowSelection')
      const index = this.rowSelected.findIndex(row => row === item);
      if (index > -1) {
        // 既に選択されている場合は削除
        this.rowSelected.splice(index, 1);
      } else {
        // 選択されていない場合は追加
        this.rowSelected.push(item);
      }
    },
    /**
     * 新規登録（回収）ボタン クリックイベント
     */
    addCollectionButtonClickEvent(planDate) {
      this.$router.push({
        name: "DriverOrderAcceptCollectionNew",
        query: { plan_date: planDate }
      });
    },
    /**
     * 新規登録（自己運搬（排出））ボタン クリックイベント
     */
    addSelfEmissionButtonClickEvent(planDate) {
      this.$router.push({
        name: "DriverOrderAcceptSelfEmissionNew",
        query: { plan_date: planDate }
      });
    },
    /**
     * 新規登録（他社）ボタン クリックイベント
     */
    addProxyRequestButtonClickEvent(planDate) {
      if (!this.isProxyEntry) {
        window.open(process.env.VUE_APP_STATION_PROXY_REQUEST_URL, '_blank');
        return;
      }
      this.$router.push({
        name: "DriverOrderAcceptProxyRequestNew",
        query: { plan_date: planDate }
      });
    },
    /**
     * 新規登録（一廃）ボタン クリックイベント
     */
    addGeneralButtonClickEvent(planDate) {
      this.$router.push({
        name: "DriverOrderAcceptGeneralNew",
        query: { plan_date: planDate }
      });
    },
    /**
     * 新規登録（搬入）ボタン クリックイベント
     */
    addCarryInButtonClickEvent(planDate) {
      this.$router.push({
        name: "DriverOrderAcceptCarryInNew",
        query: { plan_date: planDate }
      });
    },
    /**
     * 新規登録（引取）ボタン クリックイベント
     */
    addPickupButtonClickEvent(planDate) {
      this.$router.push({
        name: "DriverOrderAcceptPickupNew"
        , query: { plan_date: planDate }
      });
    },
    /**
     * 複写して作成ボタン クリックイベント
     */
    duplicatePickupButtonClickEvent() {
      this.enableDuplicateDialog = true;
    },
    /**
     * 受注登録ボタン クリックイベント
     * @param item
     */
    editButtonClickEvent(item) {
      if (item.status.match(/^collection/)) {
        if (item.has_collection_request) {
          const pathName = item.order_type === "self_emission" ? "DriverOrderAcceptSelfEmissionRegistrationEdit" : "DriverOrderAcceptCollectionRegistrationEdit"
          this.$router.push({
            name: pathName,
            params: { id: item.id },
          });
        } else {
          if (item.order_type === "self_emission") {
            this.$router.push({
              name: "DriverOrderAcceptSelfEmissionEdit",
              params: { id: item.id },
            });
          } else if (item.order_type === "proxy_request") {
            this.$router.push({
              name: "DriverOrderAcceptProxyRequestEdit",
              params: { id: item.id },
            });
          } else if (item.order_type === "general") {
            this.$router.push({
              name: "DriverOrderAcceptGeneralEdit",
              params: { id: item.id },
            });
          } else {
            this.$router.push({
              name: "DriverOrderAcceptCollectionEdit",
              params: { id: item.id },
            });
          }
        }
      } else if (item.status.match(/^pickup/)) {
        this.$router.push({
          name: "DriverOrderAcceptPickupRegistrationEdit",
          params: { id: item.id },
        });
      } else if (item.status.match(/^carry/)) {
        this.$router.push({
          name: "DriverOrderAcceptCarryInRegistrationEdit",
          params: { id: item.id },
        });
      }
    },
    /**
     * 複写ボタン クリックイベント
     * @param item
     */
    duplicateButtonClickEvent(item) {
      if (item.status.match(/^collection/)) {
        if (item.order_type === 'self_emission') {
          this.$router.push({
            name: "DriverOrderAcceptSelfEmissionDuplicate",
            params: { duplicate_id: item.id },
            query: { plan_date: this.conditions.plan_date },
          });
        } else if (item.order_type === 'proxy_request') {
          this.$router.push({
            name: "DriverOrderAcceptProxyRequestDuplicate",
            params: { duplicate_id: item.id },
            query: { plan_date: this.conditions.plan_date },
          });
        } else if (item.order_type === 'general') {
          this.$router.push({
            name: "DriverOrderAcceptGeneralDuplicate",
            params: { duplicate_id: item.id },
            query: { plan_date: this.conditions.plan_date },
          });
        } else {
          this.$router.push({
            name: "DriverOrderAcceptCollectionDuplicate",
            params: { duplicate_id: item.id },
            query: { plan_date: this.conditions.plan_date },
          });
        }
      } else if (item.status.match(/^pickup/)) {
        this.$router.push({
          name: "DriverOrderAcceptPickupDuplicate",
          params: { duplicate_id: item.id },
          query: { plan_date: this.conditions.plan_date },
        });
      } else if (item.status.match(/^carry/)) {
        this.$router.push({
          name: "DriverOrderAcceptCarryinDuplicate",
          params: { duplicate_id: item.id },
          query: { plan_date: this.conditions.plan_date },
        });
      }
    },
    /**
     * CSV出力(回収・持込・他社)ボタン クリックイベント
     */
    exportButtonClickEvent (type) {
      /** 電子契約単体プランの場合、メッセージを出して終わる */
      if (this.isEcContractSinglePlan) {
        this.enableEcContractSinglePlanGuideDialog = true
      } else {
        let params = {};
        Object.assign(params, this.conditions)
        delete params['page'];
        delete params['limit']
        delete params['format']
        params['output_type'] = type
        this.outputReserve({ conditions: params }).then(() => {
          this.blinkingButton = true;
        })
      }
    },
    /**
     * CSV取込ボタン クリックイベント
     */
    importButtonClickEvent (type) {
      /** 電子契約単体プランの場合、メッセージを出して終わる */
      if (this.isEcContractSinglePlan) {
        this.enableEcContractSinglePlanGuideDialog = true
      } else {
        this.$router.push({
          name: 'DriverOrderAcceptCsvImport',
          query: { import_type: type }
        })
      }
    },
    /**
     * 取引番号リンククリックイベント
     * @param item
     */
    transactionNoClickEvent(item) {
      this.fetchDeal({ id: item.deal_id }).then((content) => {
        if (content.status === "final_closing") {
          this.$router.push({
            name: "DriverSalesTransaction",
            params: { id: content.id },
          });
        } else {
          this.$router.push({
            name: "DriverSalesTransactionEdit",
            params: { id: content.id },
          });
        }
      });
    },
    /**
     * 予約登録 クリックイベント
     * @param item
     */
    selfEmissionReservationButtonClickEvent(item) {
      //
      let params = { order_ids: [item.id] };
      this.reservationOrders({ params: params }).then(() => {
        this.searchOrders();
      });
    },
    /**
     * 詳細を参照 クリックイベント
     * @param item
     */
    showButtonClickEvent(item) {
      if (item.status.match(/^collection/)) {
        if (item.order_type === 'self_emission') {
          this.$router.push({
            name: "DriverOrderAcceptSelfEmission",
            params: {id: item.id},
          });
        } else if ( item.order_type === 'general' ) {
          this.$router.push({
            name: "DriverOrderAcceptGeneral",
            params: { id: item.id },
          });
        }else {
          this.$router.push({
            name: "DriverOrderAcceptCollection",
            params: { id: item.id },
          });
        }

      } else if (item.status.match(/^pickup/)) {
        this.$router.push({
          name: "DriverOrderAcceptPickup",
          params: { id: item.id },
        });
      } else if (item.status.match(/^carry/)) {
        this.$router.push({
          name: "DriverOrderAcceptCarryIn",
          params: { id: item.id },
        });
      }
    },
    /**
     * 受注に戻る クリックイベント
     * @param item
     */
    backCollectionAcceptClickEvent(item) {
      this.backOrder({ id: item.id }).then(() => {
        this.searchOrders();
      });
    },
    directlyCompleteButtonClickEvent (item) {
      let modalOption = {
        title: "登録完了",
        message: "登録完了に更新します。よろしいですか？",
        options: { width: 450, isCancelButton: true },
      }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.directlyComplete({id: item.id}).then(() => {
            this.searchOrders()
          })
        }
      })
    },
    /**
     * キャンセルボタン クリックイベント
     * @param item
     */
    cancelButtonClickEvent(item) {
      if (item.can_directly_cancel) {
        // 登録完了ステータスのキャンセル
        let modalOption = {
          title: "キャンセル",
          message: "報告対象がないためキャンセルします。よろしいですか？",
          options: { width: 450, titleColor: "red", isCancelButton: true },
        }
        this.$refs.confirm.open(modalOption).then((confirm) => {
          this.$refs.confirm.close()
          if (confirm) {
            this.cancellationOrder({id: item.id}).then(() => {
              this.searchOrders()
            })
          }
        })
      } else if (item.request_no) {
        this.cancelTargetId = item.id;
        if (item.status.match(/^collection/)) {
          this.cancelTargetType = "collection";
        } else if (item.status.match(/^pickup/)) {
          this.cancelTargetType = "pickup";
        } else if (item.status.match(/^carry/)) {
          this.cancelTargetType = "carry_in";
        }
        this.enableRejectReasonDialog = true;
      } else {
        let modalOption = {
          title: "キャンセル",
          message: "キャンセルしますがよろしいですか？",
          options: { width: 320, titleColor: "red", isCancelButton: true },
        };
        this.$refs.confirm.open(modalOption).then((confirm) => {
          this.$refs.confirm.close();
          if (confirm) {
            if (item.status.match(/^collection/)) {
              this.collectionRemove(item.id);
            } else if (item.status.match(/^pickup/)) {
              this.pickupRemove(item.id);
            } else if (item.status.match(/^carry/)) {
              this.carryInRemove(item.id);
            }
          }
        });
      }
    },
    /**
     * 削除ボタン クリックイベント
     * @param item
     */
    deleteButtonClickEvent(item) {
      let modalOption = {
        title: "削除",
        message: "削除します。よろしいですか？",
        options: { width: 450, titleColor: "red", isCancelButton: true },
      }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteOrder({id: item.id}).then(() => {
            this.searchOrders()
          })
        }
      })
    },
    /**
     * マニフェスト番号 クリックイベント
     */
    manifestNumberClickEvent (item) {
      const params = { order_no: item.order_no }
      this.$router.push( { name: 'DriverManifestManagements', params: params } )
    },
    /**
     * グレードアップ誘導メッセージ表示
     */
    ecContractSinglePlanButtonClickEvent() {
      this.enableEcContractSinglePlanGuideDialog = true
    },

    changePage(page) {
      this.page = page;
      this.searchOrders();
    },
    changePerPage (perPage) {
      this.perPage = perPage
      this.page = 1
      this.searchOrders();
    },
    /**
     * 運搬終了報告 個別登録ボタン
     */
    completionReportDialogClickEvent() {
      this.targetOrderIds = [];
      for (const argument of this.rowSelected) {
        this.targetOrderIds.push(argument.id);
      }
      const params = {
        ids: this.targetOrderIds.join(","),
        report_type: "completion",
        display_type: "Accepts",
      };
      this.warningDialogMessage = null;
      this.verification({ params: params }).then((content) => {
        if (content.status === "success") {
          this.targetManifestIds = content.manifest_ids;
          this.enableCompletionDialog = true;
        } else {
          this.warningDialogMessage = content.error_message;
          this.enableWarningDialog = true;
        }
      });
    },
    /**
     * 運搬終了報告 一括登録ボタン
     */
    bulkCompletionReportDialogClickEvent() {
      this.targetOrderIds = [];
      this.targetManifestIds = [];
      for (const argument of this.rowSelected) {
        this.targetOrderIds.push(argument.id);
      }
      const params = {
        ids: this.targetOrderIds.join(","),
        report_type: "completion",
        is_bulk: true,
        display_type: "Accepts",
      };
      this.warningDialogMessage = null;
      this.verification({ params: params }).then((content) => {
        if (content.status === "success") {
          /**
           * サーバでの判定の結果、登録対象が排出持込のみであった場合は本登録処理へ
           * @property content.only_self_emission { Boolean } 排出持込のみであるかどうか
           * @property detail.order_id {  Number } 受注ID
           * @property detail.processable_manifest_ids {  Array } 処理可能なマニフェストID
           */
          if (content.only_self_emission) {

            let modalOption = {
              title: "一括本登録",
              message: "一括本登録を行います。よろしいですか？",
              options: { width: 450, isCancelButton: true },
            }

            let parameters = []
            for (const detail of content.details) {
              parameters.push({ order_id: detail.order_id, manifest_ids: detail.processable_manifest_ids })
            }
            this.$refs.confirm.open(modalOption).then((confirm) => {
              this.$refs.confirm.close()
              if (confirm) {
                this.selfEmissionDefinitiveRegistration({ params: { targets: parameters} }).then(() => {
                  this.searchOrders();
                })
              }
            })
          } else {
            this.targetManifestIds = content.manifest_ids;
            this.enableBulkCompletionDialog = true;
          }
        } else {
          this.warningDialogMessage = content.error_message;
          this.enableWarningDialog = true;
        }
      });
    },


    /**
     * テーブルヘッダの生成
     */
    buildTableHeader() {
      this.fixedTableHeader = [
        { text: "ステータス\r\nマニフェスト", value: "status", width: '10%' },
        { text: "受注番号\r\n受注日", value: "order_no", align: "center", width: '10%' },
        { text: "依頼番号\r\n依頼日", value: "request_no", align: "center", width: '5%' },
        { text: "回収・積替・搬入日\r\nドライバー", value: "target_date", width: '10%' },
        { text: '承認\r\n状況', value: 'remand_count', width: '5%' },
        { text: "取引先（事業者）\r\n取引先（事業場）", value: "supplier", width: '20%' },
        { text: "運搬先事業場\r\n処分事業場", value: "destination_location", width: '20%' },
        { text: "品目\r\n荷姿", value: "item", width: '10%' },
        { text: "取引番号\r\n合計金額", value: "deal_no", align: "center", width: '5%' },
        { text: "編集", value: "editable", align: "end", width: '5%' },
      ];
      if (!this.isBilling) {
        this.fixedTableHeader = this.fixedTableHeader.filter(
          (v) => v.value !== "deal_no"
        );
      }
    },
    /**
     * 「産廃回収（受注）」が編集可能であるかを返します.
     * 複数箇所でコールするためメソッド化
     * @param item
     * @return {boolean}
     */
    canEditCollectionAccepted(item) {
      if (this.isAllocate) {
        return "collection_accepted" === item.status && !item.driver;
      } else {
        return "collection_accepted" === item.status || "collection_transported" === item.status;
      }
    },
    /**
     * 編集画面へ遷移できるか検証します.
     * @param item
     * @return {boolean}
     */
    canTransitionToEdit(item) {
      /*
       * collection_requested: 産廃回収（未受付）
       * pickup_requested: 積替運搬（未受付）
       * carry_in_contacted: 搬入予約（未受付）
       */
      if (
        [
          "collection_requested",
          "pickup_requested",
          "carry_in_contacted",
        ].includes(item.status)
      ) {
        return true;
      /*
       * collection_accepted: 産廃回収（受注）ドライバーなし(配車紐付けなし)
       * collection_transported: 産廃回収（運搬完了）
       */
      } else if (this.canEditCollectionAccepted(item)) {
        return true;
      }
      return false;
    },
    /**
     * 検索パターンタブチェンジ コールバック
     * @param item
     */
    selectableConditionPatternChangeCallback(item) {
      this.stopSearch = true;
      // this.$refs.searchBlock.clearAllSelectableMembers();
      if (item === 0) {
        this.$nextTick(() => {
          Object.assign(this.$data.conditions, this.$options.data().conditions);
          this.searchButtonClickEvent()
        })
      } else if (item > 0) {
        const pattern = this.conditionPatterns[item - 1];
        this.fetchConditionPattern({ id: pattern.id }).then((content) => {
          this.$nextTick(()=> {
            this.conditions = content.conditions
            this.searchButtonClickEvent()
          })
        })
      }

    },
    handleUserTabChange () {},
    addConditionPatternCallback (item) {
      this.conditionPatterns.push(item);
      this.selectableConditionPattern = this.conditionPatterns.length;
      this.selectableConditionPatternChangeCallback(this.selectableConditionPattern);
    },
    removeConditionPatternCallback (value) {
      const pattern = this.conditionPatterns[value - 1]
      if (pattern) {
        this.destroyConditionPattern({id: pattern.id}).then(() => {
          // タブを移動
          this.selectableConditionPattern = 0
          this.selectableConditionPatternChangeCallback(0);
          this.loadConditionPatterns();
        })
      }
    },
    searchCallback() {
      this.page = 1;

      this.searchOrders();
    },
    clearCallback (value) {
      this.selectableConditionPatternChangeCallback(value)
    },
    /**
     * 検索パターン読込
     */
    loadConditionPatterns() {
      /**
       * @param content { Object }
       * @property content.condition_patterns { Array }
       */
      this.fetchConditionPatterns({ classification: "orders" }).then(
        (content) => {
          this.conditionPatterns = content.condition_patterns;
        }
      );
    },

     /**
     * ダイアログ 閉じるボタンコールバック
     */
    dialogCloseCallback() {
      this.enableCompletionDialog = false;
      this.enableBulkCompletionDialog = false;
      this.enableDuplicateDialog = false;
      this.enableRejectReasonDialog = false;
      this.enableEcContractSinglePlanGuideDialog = false;
    },
    /**
     * 複写して作成ダイアログコールバック
     * 渡された受注の種別により遷移先が決定する.
     * @param order { Object }
     */
    duplicateOrderDialogCallback(order) {
      if (order.status.match(/^collection/)) {
        if (order.order_type === 'self_emission') {
          this.$router.push({
            name: "DriverOrderAcceptSelfEmissionDuplicate",
            params: { duplicate_id: order.id},
            query: { plan_date: this.conditions.plan_date }
          });
        } else if (order.order_type === "proxy_request") {
          this.$router.push({
            name: "DriverOrderAcceptProxyRequestDuplicate",
            params: { duplicate_id: order.id},
            query: { plan_date: this.conditions.plan_date }
          });
        } else if (order.order_type === "general") {
          this.$router.push({
            name: "DriverOrderAcceptGeneralDuplicate",
            params: { duplicate_id: order.id},
            query: { plan_date: this.conditions.plan_date }
          });
        } else {
          this.$router.push({
            name: "DriverOrderAcceptCollectionDuplicate",
            params: { duplicate_id: order.id },
            query: { plan_date: this.conditions.plan_date }
          });
        }
      } else if (order.status.match(/^pickup/)) {
        this.$router.push({
          name: "DriverOrderAcceptPickupDuplicate",
          params: { duplicate_id: order.id },
          query: { plan_date: this.conditions.plan_date }
        });
      } else if (order.status.match(/^carry/)) {
        this.$router.push({
          name: "DriverOrderAcceptCarryinDuplicate",
          params: { duplicate_id: order.id },
          query: { plan_date: this.conditions.plan_date },
        });
      }

      this.dialogCloseCallback();
    },
    /**
     * 否決理由登録ダイアログ コールバック
     * @param form
     */
    rejectReasonDialogCallback(form) {
      const params = { rejection_reason: form.rejectionReason };
      if (this.cancelTargetType === "collection") {
        this.rejectCollection({ id: this.cancelTargetId, params: params }).then(
          () => {
            this.searchOrders();
            this.dialogCloseCallback();
          }
        );
      } else if (this.cancelTargetType === "pickup") {
        // 否決通知
        this.rejectionPickup({ id: this.cancelTargetId, params: params }).then(
          () => {
            this.searchOrders();
            this.dialogCloseCallback();
          }
        );
      } else if (this.cancelTargetType === "carry_in") {
        this.rejectionCarryIn({ id: this.cancelTargetId, params: params }).then(
          () => {
            this.searchOrders();
            this.dialogCloseCallback();
          }
        );
      }
    },
    searchOrders() {
      this.rowSelected = null;
      this.rowSelected = [];
      this.fetchSummaries().then((content) => {
        this.summaries = content;
      });
      let params = {
        ...this.conditions,
        status: this.selectedButton === undefined ? null : this.selectedButton,
      }
      this.fetchOrders({ conditions: params, selectable_tab: this.selectableConditionPattern, page: this.page, limit: this.perPage }).then((content) => {
        this.orders = content.orders;
        this.stopSearch = false;
      });
    },
    buildParam() {
      return {
        status: this.selectedButton === undefined ? null : this.selectedButton,
        page: this.page,
        limit: this.perPage,
        keyword: this.searchForms.keyword,
        supplier_id: this.searchForms.supplierId,
        supplier_type: this.searchForms.supplierType,
        supplier_name: this.searchForms.supplierName,
        supplier_location_key: this.searchForms.supplierLocationKey,
        emission_location_id: this.searchForms.emissionLocationId,
        report_transport_user_id: this.searchForms.reportTransportUserId,
        report_transport_user_name: this.searchForms.reportTransportUserName,
        driver_id: this.searchForms.driverId,
        driver_name: this.searchForms.driverName,
        order_type: this.searchForms.orderType,
        collected_date_type: this.searchForms.collectedDateType,
        collected_start_date: this.searchForms.collectedStartDate,
        collected_end_date: this.searchForms.collectedEndDate,
        vote_staff: this.searchForms.voteStaff,
        order_number: this.searchForms.orderNumber,
        request_number_flag: this.searchForms.requestNumberFlag,
        request_number: this.searchForms.requestNumber,
        deal_number_flag: this.searchForms.dealNumberFlag,
        deal_number: this.searchForms.dealNumber,
        waste_name: this.searchForms.wasteName,
        manifest_type: this.searchForms.manifestType,
        approval_state: this.searchForms.approvalState,
        sort_type: this.searchForms.sortType,
        search_keyword: this.searchForms.searchKeyword,
        manifest_search_keyword: this.searchForms.manifestSearchKeyword,
        location_code: this.searchForms.locationCode,
        location_name: this.searchForms.locationName,
        target_date: this.searchForms.target_date,
        plan_date: this.searchForms.planDate,
        transport_route_id: this.searchForms.transport_route_id
      };
    },
    /**
     * 受渡確認票出力ボタン クリックイベント
     * @description 受渡確認票を別タブにて表示する
     */
    outputManifestButtonClickEvent() {
      let selectedIds = this.rowSelected.map((v) => v.id);
        const params = {
          targets: selectedIds
        };
        this.slipVerification({ params: params }).then((content) => {
          if (content.status === "success") {
            let resolvedRoute = this.$router.resolve({
              name: "DriverOrderConfirmationSlips",
              query: { targets: selectedIds, sort_type: this.conditions.sort_type },
            });
            window.open(resolvedRoute.href, "_blank");
          } else {
            this.warningDialogMessage = content.error_message;
            this.enableWarningDialog = true;
          }
      });
    },
    /**
     * 一覧表出力ボタン クリックイベント
     * @description 一覧表を別タブにて表示する
     */
     outputListButtonClickEvent() {
      let selectedIds = this.rowSelected.map((v) => v.id);
      const params = {
        mode: 'all',
        targets: selectedIds
      };
      this.listVerification({ params: params }).then((content) => {
        if (content.status === "success") {
          let resolvedRoute = this.$router.resolve({
            name: "DriverOrderConfirmationLists",
            query: { mode: 'all', targets: selectedIds, sort_type: this.conditions.sort_type },
          });
          window.open(resolvedRoute.href, "_blank");
        } else {
          this.warningDialogMessage = content.error_message;
          this.enableWarningDialog = true;
        }
      });
    },

    cancellationButtonClickEvent() {
      const isDeleteMode = this.selectedButton === 'canceled';
      let modalOption = {
        title: isDeleteMode ? "削除" : "キャンセル",
        message: isDeleteMode ? "削除します。よろしいですか？" : "キャンセルします。よろしいですか？",
        options: { titleColor: "red" },
      };
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close();
        if (confirm) {
          let ids = this.rowSelected.map((v) => {
            return v.id;
          });
          let params = {
            order_ids: ids,
            action_type: isDeleteMode ? 'delete' : 'cancel'
          };
          this.cancelCollectionOrder({ params: params }).then(() => {
            this.searchOrders();
          });
        }
      });
    },

    reservationButtonClickEvent() {
      let modalOption = {
        title: "予約登録",
        message: "予約登録します。よろしいですか？",
        options: { titleColor: "blue" },
      };
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close();
        if (confirm) {
          let ids = this.rowSelected.map((v) => {
            return v.id;
          });
          let params = { order_ids: ids };
          this.reservationOrders({ params: params }).then(() => {
            this.searchOrders();
          });
        }
      });
    },

    editDialogRegisterCallback() {
      this.dialogCloseCallback();
      this.searchOrders();
    },

    collectionRemove(id) {
      this.deleteCollection({ id: id }).then((result) => {
        if (result.code === 409001) {
          this.removeErrorMessage = result.message;
          this.removeErrorDialog = true;
        } else {
          this.searchOrders();
        }
      });
    },
    pickupRemove(id) {
      this.deletePickup({ id: id }).then((result) => {
        if (result.code === 409001) {
          this.removeErrorMessage = result.message;
          this.removeErrorDialog = true;
        } else {
          this.searchOrders();
        }
      });
    },
    carryInRemove(id) {
      this.deleteCarryIn({ id: id }).then((result) => {
        if (result.code === 409001) {
          this.removeErrorMessage = result.message;
          this.removeErrorDialog = true;
        } else {
          this.searchOrders();
        }
      });
    },

    /**
     * 前の週に移動
     */
    moveToPreviousWeek() {
      this.weekStartDate = this.$dayjs(this.weekStartDate).subtract(7, 'days').format('YYYY-MM-DD');
    },

    /**
     * 次の週に移動
     */
    moveToNextWeek() {
      this.weekStartDate = this.$dayjs(this.weekStartDate).add(7, 'days').format('YYYY-MM-DD');
    },

    /**
     * 日付ボタンクリック
     * @param date - クリックされた日付（YYYY-MM-DD形式）
     */
    dateButtonClick(date) {
      // 既に選択されている日付をクリックした場合は選択解除
      if (this.conditions.target_date === date) {
        this.conditions.target_date = null;
        this.conditions.plan_date = null;
        this.conditions.collected_start_date = null;
        this.conditions.collected_end_date = null;
      } else {
        // 選択された日付を設定
        this.conditions.target_date = date;
        this.conditions.plan_date = date;
        this.conditions.collected_start_date = date;
        this.conditions.collected_end_date = date;
      }

      // 検索を実行
      this.searchButtonClickEvent();
    },
    /**
     * 該当の受注データが複写可能かどうかを判定します。
     * 
     * @param {Object} item 対象の受注データ
     * @return {boolean} 複写可能な場合は true
     */
    canDuplicateOrder(item) {
      // 1. キャンセル済みのステータスは複写不可
      if (['collection_canceled', 'pickup_canceled', 'carry_canceled'].includes(item.status)) {
        return false;
      }

      // 2. 他社運搬の場合、他社運搬機能（isProxyEntry）が有効でなければ複写不可
      if (item.order_type === 'proxy_request' && !this.isProxyEntry) {
        return false;
      }

      // 3. 搬入の場合、自社作成（self_make_order）でなければ複写不可
      if (item.order_type === 'carryin' && !item.self_make_order) {
        return false;
      }

      // すべての条件をクリアした場合は複写可能
      return true;
    },
  },
};
</script>

<style scoped lang="scss">
.breaker {
  display: block;
  margin-top: 0;
  padding-top: 0;
  line-height: 0.5rem;
}
.breaker::after {
  content:"\A";
  white-space:pre;
}

.panel-header-color {
  color: #0d74ba !important;
  & .v-expansion-panel-header__icon {
    & .v-icon {
      color: #0d74ba !important;
      &::before {
        color: #0d74ba !important;
      }
    }
  }
}
.panel-selectable {
  background-color: #dce7eb;
}
.selectedCard {
  border-color: red !important;
}
.to-small-font {
  font-size: 85%;
}
.status-card {
  & .image-col {
    padding-top: 0;
    padding-bottom: 0;
    display: inline-flex;
  }
  & .status-col {
    padding-left: 0;
    padding-right: 0;
  }
}
.inline-flex-container {
  display: inline-flex;
  align-items: center;
  gap: 0;
  max-width: 100%;
}
.ellipsis-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.map-icon {
  flex-shrink: 0;
}
.date-button {
  width: 48px !important;
  height: 48px !important;
  min-width: 48px !important;
  border-radius: 0px !important;
  font-size: 0.75rem !important;
  padding: 0 !important;
}
.date-button.today-border {
  border: 1px solid #1976D2 !important;
  box-shadow: 0 0 4px rgba(25, 118, 210, 0.5) !important;
}
</style>
